import React from "react";

const SvgBBiconsZalozka = props => (
    <svg viewBox="0 0 200 200"  {...props}>
        <g id="Obecné_ikony" data-name="Obecné ikony">
            <path d="M68.78,28.38h62.65a16.7,16.7,0,0,1,16.7,16.69V180l-48-22-48,22V45.07A16.7,16.7,0,0,1,68.78,28.38Z" />
        </g>
    </svg>
);

export default SvgBBiconsZalozka;

